import styled from 'styled-components';
import { buttonMixin, colorMixin, sizeMixin } from './ButtonMixins';

export const LinkButton = styled.div`
  ${buttonMixin} ${sizeMixin} ${(props) => colorMixin(props, 'link')};
  text-align: center;
  border: none;
  text-transform: none;
  font-size: 14px;
  &:hover {
    text-decoration: underline;
  }
`;
